// removed by extract-text-webpack-plugin
module.exports = {"backer":"backer___2O509","choice":"choice___raGG2","select":"select___2vl24"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/ChoiceFromDataSourceColumnNameEditor/styles.scss
// module id = 419
// module chunks = 0